/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsFooter_viewer = {
    readonly visuallySimilarGridItems?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_viewer" | "PdpRespComplementaryItemsGrid_viewer">;
    readonly " $refType": "PdpRespSimilarItemsFooter_viewer";
};
export type PdpRespSimilarItemsFooter_viewer$data = PdpRespSimilarItemsFooter_viewer;
export type PdpRespSimilarItemsFooter_viewer$key = {
    readonly " $data"?: PdpRespSimilarItemsFooter_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsFooter_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isArt",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isArt",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "visuallySimilarGridItems",
          "name": "visualSearch",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 6
            },
            {
              "kind": "Variable",
              "name": "itemPk",
              "variableName": "itemId"
            }
          ],
          "concreteType": "VisualSearchConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "VisualSearchEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "serviceId",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespSimilarItemsGrid_similarItems",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespComplementaryItemsGrid_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '676208e9a8b714e6e268e3996f020555';
export default node;
